export enum DigitalizationProjectStatus {
  ACTIVE = 'active',
}
